export default function PluSelector(props) {
  const { pluOptions, lotNumber, onSelectPlu } = props;

  if (!pluOptions || pluOptions.length === 0) {
    return null;
  }

  return (
    <div className="flow-root overflow-x-auto mt-4">
      <div className="inline-block min-w-full py-2 align-middle">
        <h3 className="text-lg mb-2">Select a Manufactured Product to trace</h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {pluOptions.map((item) => (
            <button
              key={item.id ?? item.plu}
              type="button"
              onClick={() => onSelectPlu(item.id)}
              className="block w-full text-left p-4 rounded-lg border border-gray-200 bg-white hover:bg-gray-50 hover:border-main-purple focus:outline-none focus:ring-2 focus:ring-main-purple focus:ring-offset-2 transition-colors"
            >
              <p className="font-semibold text-gray-900">
                {item.product_name ?? item.plu}
              </p>
              {item.plu != null && (
                <p className="text-sm text-gray-500 mt-1">PLU: {item.plu}</p>
              )}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
